export default __webpack_public_path__ + "static/media/Jason-Zommick.3e32d072.png";